require("!!/Users/Jeng/Desktop/Projects/angular-queue/node_modules/script-loader/addScript.js")(require("!!/Users/Jeng/Desktop/Projects/angular-queue/node_modules/raw-loader/index.js!/Users/Jeng/Desktop/Projects/angular-queue/node_modules/bootstrap/dist/js/bootstrap.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/dist/js/bootstrap.js
// module id = 91
// module chunks = 3